import React from 'react';

const PoliticaDePrivacidad = () => {
  return (
    <div className="bg-gray-100 text-gray-800 py-10 px-5 sm:px-10 md:px-20 lg:px-40">
      <div className="bg-white border-2 border-GrisOscuro rounded-lg p-6">
        <h1 className="text-2xl md:text-3xl font-bold mb-6 text-center">Política de Privacidad</h1>

        <p className="mb-4">
          En AgroH, estamos profundamente comprometidos con la protección de la privacidad y la seguridad de los datos personales
          de nuestros clientes y visitantes del sitio web. Esta Política de Privacidad tiene como finalidad informarte de manera clara
          y precisa sobre cómo recopilamos, utilizamos, protegemos y gestionamos tu información personal, en conformidad con la
          legislación vigente en materia de protección de datos.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-4">1. Introducción</h2>
        <p className="mb-4">
          Al acceder o utilizar los servicios proporcionados a través de nuestro sitio web, aceptas los términos y condiciones establecidos
          en esta política. Te instamos a leer este documento detenidamente antes de proporcionarnos cualquier dato personal.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-4">2. Información que Recopilamos</h2>
        <ul className="list-disc list-inside mb-4">
          <li>Información de contacto: nombre, correo electrónico, teléfono y dirección proporcionados en formularios de contacto.</li>
          <li>Información técnica: datos como dirección IP, navegador y dispositivo utilizado al visitar nuestro sitio.</li>
          <li>Cookies: usamos cookies para mejorar la experiencia de navegación y analizar el uso del sitio web.</li>
        </ul>

        <h2 className="text-xl font-bold mt-6 mb-4">3. Finalidades del Tratamiento de la Información</h2>
        <p className="mb-4">
          La información recopilada es utilizada para:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>Responder a consultas realizadas a través de formularios de contacto.</li>
          <li>Mejorar y personalizar la experiencia en nuestro sitio web.</li>
          <li>Cumplir con obligaciones legales y regulatorias.</li>
        </ul>

        <h2 className="text-xl font-bold mt-6 mb-4">4. Protección de los Datos Personales</h2>
        <p className="mb-4">
          Implementamos medidas de seguridad adecuadas para proteger la información personal, incluyendo cifrado de datos y sistemas de control de acceso. 
          Sin embargo, no podemos garantizar una seguridad absoluta.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-4">5. Compartición de Datos con Terceros</h2>
        <p className="mb-4">
          Compartimos datos personales solo con:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>Proveedores de servicios tecnológicos que nos ayudan a operar el sitio web.</li>
          <li>Autoridades legales cuando es requerido por la ley.</li>
        </ul>

        <h2 className="text-xl font-bold mt-6 mb-4">6. Derechos de los Titulares de los Datos</h2>
        <p className="mb-4">
          Los clientes pueden ejercer los siguientes derechos sobre sus datos personales:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>Acceso, rectificación, y eliminación de los datos personales.</li>
          <li>Oposición al tratamiento de los datos personales.</li>
        </ul>
        <p className="mb-4">
          Para ejercer estos derechos, puedes contactarnos a través del correo electrónico: <span className="font-bold">asistente@agroh.info</span>
        </p>

        <h2 className="text-xl font-bold mt-6 mb-4">7. Uso de Cookies</h2>
        <p className="mb-4">
          Utilizamos cookies para mejorar la funcionalidad del sitio y personalizar la experiencia del usuario. Puedes configurar tu navegador para deshabilitar las cookies si lo deseas.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-4">8. Modificaciones a la Política de Privacidad</h2>
        <p className="mb-4">
          Esta política puede ser actualizada periódicamente. Recomendamos revisarla con regularidad para mantenerse informado sobre cómo protegemos tus datos.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-4">9. Contacto</h2>
        <p className="mb-4">
          Si tienes preguntas sobre esta Política de Privacidad, puedes contactarnos:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>Correo electrónico: <span className="font-bold">asistente@agroh.info</span></li>
          <li>Teléfono: <span className="font-bold">+54 381 5585138</span></li>
        </ul>
        <p className="text-sm text-gray-600 mt-4">Última actualización: 01/01/2025</p>
      </div>
    </div>
  );
};

export default PoliticaDePrivacidad;
